// This file was automatically generated from ptdata.rxHistoryDownloadSummaries.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.rxHistoryDownloadSummaries');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.rxHistoryDownloadSummaries.description = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.fillsCount), ' medication fill', (opt_data.fillsCount != 1) ? 's' : '', ' received', (opt_data.eligPatientFullName) ? ' for ' + soy.$$escapeHtml(opt_data.eligPatientFullName) + ' (' + soy.$$escapeHtml(opt_data.eligPatientSex) + ')' + ((opt_data.eligPatientDob) ? ' ' + (soy.$$escapeHtml(opt_data.eligPatientDob)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.eligPatientDob)) : '') : '') : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.rxHistoryDownloadSummaries.noteSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((soy.$$escapeHtml(opt_data.chartFeedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.chartFeedDate)) : ''), ' medication fills report');
  if (!opt_sb) return output.toString();
};
